/* eslint-disable */
import React, { useState, useRef, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from "react-redux";
import {
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    Avatar,
    IconButton,
    Chip,
    Typography,
    FormControlLabel,
    Switch,
    Grid,
    MenuItem,
    Tabs,
    Tab,
    FormControl,
    InputLabel,
    Select,
    FormHelperText
} from '@mui/material';
import { FirebaseContext } from 'common';
import { CloudUpload, Delete as DeleteIcon } from '@mui/icons-material';
import { motion, AnimatePresence } from 'framer-motion'
function TabPanel(props) {
    const { api } = useContext(FirebaseContext);
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`agent-tabpanel-${index}`}
            aria-labelledby={`agent-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
        </div>
    );
}

const AgentFormComponent = ({ onClose, onSubmit, sourceData, officeData }) => {
    const { api } = useContext(FirebaseContext);
    const {
        AddBroker,
        EditBroker,
        fetchAllBranches
    } = api;

    const branchManagementReducer = useSelector((state) => state.branchData);

    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const [branchData, setBranchdata] = useState([]);
    const [formData, setFormData] = useState({
        // id: auth.info.uid,
        firstname: '',
        lastname: '',
        Firebaseusertype: "broker",
        // receiveStatsMail: true,
        // published: true,

        //new fields
        id: "",
        agentId: "",
        websiteID: "",
        PPagentId: "",
        branchId: "",
        privysealAlias: "",
        registrationNumber: "",
        vatNumber: "",
        password: "",
        //end of new fields
        agencyId: "",
        cityId: 123,
        sourceReference: '',
        mobileNumber: '',
        emailAddress: '',
        brokerHomeOffice: "",
        faxNumber: '',
        workNumber: '',
        qualification: '',
        fidelityFundCertificationYear: '',
        fidelityFundCertificationNumber: '',
        idNumber: '',
        incomeTaxNumber: '',
        about: '',
        licenseImage: null,
        brokerImage: null,
        // isBroker: false,
        countryId: 1,
        profilePicture: null,
        profile: {
            facebook: '',
            twitter: ''
        },
        status: 'Active',
        jobTitle: '',
        imageFile: null,
    });

    useEffect(() => {
        fetchData();
    }, [])

    useEffect(() => {
        setBranchdata(branchManagementReducer?.branches)
        console.log("branchdata:", branchData);
    }, [branchManagementReducer.branches]);

    async function fetchData() {
        await dispatch(fetchAllBranches())
    }

    function randomString(length) {
        const chars = 'abcdefghijklmnopqrstuvwxyz';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    }


    function randomDigits(length) {
        let result = '';
        for (let i = 0; i < length; i++) {
            result += Math.floor(Math.random() * 10);
        }
        return result;
    }

    function getRandomDummyAgent() {
        const first = randomString(5);
        const last = randomString(7);
        const username = `${first}.${last}`;
        const email = `${first}.${last}${randomDigits(2)}@plum.systems`;
        // +27, then 9 digits (no leading zero after 27)
        const mobile = '+2768' + randomDigits(7);
        const work = '+2768' + randomDigits(7);
        return {
            id: "TEST" + randomDigits(20),
            firstname: first.charAt(0).toUpperCase() + first.slice(1),
            lastname: last.charAt(0).toUpperCase() + last.slice(1),
            Firebaseusertype: "broker",
            agentId: "PP" + randomDigits(6),
            branchId: "BR-" + randomDigits(2),
            privysealAlias: username,
            registrationNumber: "REG-2025-" + randomDigits(3),
            vatNumber: "VAT" + randomDigits(6),
            password: "PASSWORD!@#" + randomDigits(3),
            agencyId: "42",
            cityId: "1001",
            sourceReference: "import-" + randomDigits(3),
            mobileNumber: mobile,
            emailAddress: email,
            faxNumber: "021" + randomDigits(7),
            workNumber: work,
            qualification: "BCom (Real Estate)",
            fidelityFundCertificationYear: "2022",
            fidelityFundCertificationNumber: "FFC-2022-" + randomDigits(4),
            idNumber: randomDigits(13),
            incomeTaxNumber: "ITN-" + randomDigits(6),
            about: "Experienced broker specialised in residential sales.",
            countryId: "24",
            status: "Active",
            jobTitle: "Broker",
            profile: {
                facebook: `https://www.facebook.com/${username}`,
                twitter: `https://twitter.com/${username}`
            },
            profilePicture: {
                bytes: "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGMAAQAABQABDQottAAAAABJRU5ErkJggg==",
                mimeContentType: "image/png",
                caption: "Test profile picture"
            }
        };
    }

    const [imagePreview, setImagePreview] = useState(null);
    const fileInputRef = useRef(null);
    const [tabValue, setTabValue] = useState(0);;
    const [errors, setErrors] = useState({});
    const licenseInputRef = useRef(null);
    const brokerInputRef = useRef(null);

    useEffect(() => {
        if (sourceData) {
            setFormData(prev => ({
                ...prev,
                ...sourceData,
                agentId: sourceData.agentId || sourceData.agentID || '',
                PPagentId: sourceData.PPagentId || sourceData.PPagentId || '',
                websiteID: sourceData.websiteID || sourceData.websiteId || '',
                firstname: sourceData.firstname || sourceData.firstName || sourceData.name?.split(' ')[0] || '',
                lastname: sourceData.lastname || sourceData.lastName || sourceData.name?.split(' ')[1] || '',
                emailAddress: sourceData.emailAddress || sourceData.email || '',
                mobileNumber: sourceData.mobileNumber || sourceData.mobile || sourceData.phone || '',
                workNumber: sourceData.mobileNumber || sourceData.mobile || sourceData.phone || '',
                brokerHomeOffice: sourceData.brokerHomeOffice || '',


                idNumber: sourceData.idNumber || sourceData.identityNumber || '',
            }));
        }
    }, [sourceData]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };




    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;


        setErrors(prev => ({ ...prev, [name]: '' }));


        console.log('value', value)
        console.log('name', name);


        if (name === "brokerHomeOffice") {
            console.log('officeData', officeData)

            
        }

        if (type === 'checkbox') {
            setFormData(prev => ({
                ...prev,
                [name]: checked
            }));
        } else if (name.startsWith('profile.')) {
            const profileField = name.split('.')[1];
            setFormData(prev => ({
                ...prev,
                profile: {
                    ...prev.profile,
                    [profileField]: value
                }
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const saveBranchData = (e) => {
        const { name, value } = e.target;

        let agencyId
        const branches = branchData

        branches?.forEach(branch => {
            if (branch.BranchName === value) {
                agencyId = branch.agencyId
            }
        })

        console.log(`agencyId: ${agencyId}`)
        console.log(`name ${name}, value: ${value}`)

        setFormData(prev => ({
            ...prev,
            [name]: value,
            agencyId: agencyId
        }));

        console.log(formData.agencyId)
    };

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (!file.type.startsWith('image/')) {
            alert('Please select an image file');
            return;
        }

        // Create preview
        const reader = new FileReader();
        reader.onload = (e) => {
            setImagePreview(e.target.result);
        };
        reader.readAsDataURL(file);

        // Convert image to base64 and store in formData.profilePicture.bytes
        const base64Reader = new FileReader();
        base64Reader.onload = (e) => {
            const base64 = e.target.result.split(',')[1]; // Remove data URL prefix
            setFormData(prev => ({
                ...prev,
                file: file,
                profilePicture: {
                    bytes: base64,
                    mimeContentType: file.type,
                    caption: `Profile picture of ${prev.firstname} ${prev.lastname}`.trim() || 'Agent profile picture'
                }
            }));
        };
        base64Reader.readAsDataURL(file);
    };


    const removeImage = () => {
        setImagePreview(null);
        setFormData(prev => ({
            ...prev,
            profilePicture: null
        }));
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     console.log("form data:", formData)
    //     dispatch(AddBroker(formData))
    // };

    // Improved validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+27\d{9}$/;
    const numberRegex = /^\d+$/;
    const urlRegex = /^(https?:\/\/)?([\w.-]+)\.([a-zA-Z]{2,})([\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/;

    const requiredByTab = {
        0: ['firstname', 'lastname', 'emailAddress', 'password', 'idNumber'],
        1: ['mobileNumber', 'workNumber'],
        // 2: ['qualification', 'fidelityFundCertificationYear', 'fidelityFundCertificationNumber'],
        3: ['profilePicture']
    };

    const validateForTab = (tabIndex) => {
        const tabErrors = {};
        const fields = requiredByTab[tabIndex] || [];
        fields.forEach((f) => {
            const value = formData[f];
            if (!value || String(value).trim() === '') {
                tabErrors[f] = 'This field is required';
            } else {
                // Custom validation for email
                if (f === 'emailAddress' && !emailRegex.test(value)) {
                    tabErrors[f] = 'Enter a valid email (must contain @ and a domain)';
                }
                // Custom validation for mobile number
                if (f === 'mobileNumber' && !phoneRegex.test(value)) {
                    tabErrors[f] = 'Mobile number must start with +27 and be 12 digits (e.g. +27812345678)';
                }
                // Custom validation for password length
                if (f === 'password' && value.length < 12) {
                    tabErrors[f] = 'Password must be at least 12 characters long';
                }
            }
        });
        return tabErrors;
    };

    const validateAllTabs = () => {
        return Object.keys(requiredByTab).reduce((acc, tabKey) => {
            const tabIdx = Number(tabKey);
            return { ...acc, ...validateForTab(tabIdx) };
        }, {});
    };


    const handleNext = () => {
        const tabErrors = validateForTab(tabValue);
        console.log("handleNext - tab:", tabValue, "errors:", tabErrors);

        if (Object.keys(tabErrors).length > 0) {
            setErrors(prev => ({ ...prev, ...tabErrors }));

            const firstField = Object.keys(tabErrors)[0];
            const el = document.getElementsByName(firstField)[0];
            if (el && typeof el.focus === "function") {
                el.focus();
            } else {
                window.alert(`Please fill required fields: ${Object.keys(tabErrors).join(", ")}`);
            }
            return;
        }

        setTimeout(() => {
            setTabValue(v => Math.min(v + 1, 3));
            setErrors(prev => {
                const copy = { ...prev };
                Object.keys(validateForTab(tabValue + 1) || {}).forEach(f => delete copy[f]);
                return copy;
            });
        }, 0);
    };



    const handleBack = () => setTabValue(v => Math.max(v - 1, 0));

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Submitting form data:", formData);
        if (sourceData) {
            dispatch(EditBroker(formData, sourceData.id));
        } else {
            dispatch(AddBroker(formData));
        }
    };


    // useEffect(() => {
    //     setFormData(getRandomDummyAgent());
    // }, []);






    return (
        <Box component="form" onSubmit={handleSubmit}>
            <DialogTitle>
                {sourceData ? `Create Agent from ${sourceData.name || sourceData.firstname || 'Record'}` : 'Add New Agent'}
            </DialogTitle>

            <Tabs value={tabValue} sx={{ px: 3, mb: 2 }} variant="scrollable" scrollButtons="auto">
                <Tab label="Basic Info" />
                <Tab label="Contact Details" />
                <Tab label="Professional Info" />
                <Tab label="Profile & Image" />
            </Tabs>

            <DialogContent sx={{ maxHeight: '70vh', overflow: 'auto', background: '#f9f9f9', borderRadius: 2, mt: 1 }}>
                {sourceData && (
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Prefilled from existing record
                    </Typography>
                )}

                {/* Basic Info Tab */}
                <TabPanel value={tabValue} index={0}>
                    <Grid container spacing={3}>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="firstname"
                                label="First Name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={formData.firstname}
                                onChange={handleChange}
                                error={!!errors.firstname}
                                helperText={errors.firstname}
                                required
                            />
                        </Grid>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="lastname"
                                label="Last Name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={formData.lastname}
                                onChange={handleChange}
                                error={!!errors.lastname}
                                helperText={errors.lastname}
                                required
                            />
                        </Grid>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="emailAddress"
                                label="Email Address"
                                type="email"
                                fullWidth
                                variant="outlined"
                                value={formData.emailAddress}
                                onChange={handleChange}
                                error={!!errors.emailAddress}
                                helperText={errors.emailAddress}
                                required
                            />
                        </Grid>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="password"
                                label="Password"
                                type={showPassword ? "text" : "password"}
                                fullWidth
                                variant="outlined"
                                value={formData.password}
                                onChange={handleChange}
                                error={!!errors.password}
                                helperText={errors.password}
                                required
                                InputProps={{
                                    endAdornment: (
                                        <Button onClick={() => setShowPassword((v) => !v)} size="small">
                                            {showPassword ? "Hide" : "Show"}
                                        </Button>
                                    )
                                }}
                            />
                        </Grid>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="idNumber"
                                label="ID Number"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={formData.idNumber}
                                onChange={handleChange}
                                error={!!errors.idNumber}
                                helperText={errors.idNumber}
                            />
                        </Grid>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="incomeTaxNumber"
                                label="Income Tax Number"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={formData.incomeTaxNumber}
                                onChange={handleChange}
                                error={!!errors.incomeTaxNumber}
                                helperText={errors.incomeTaxNumber}
                            />
                        </Grid>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="about"
                                label="About"
                                type="text"
                                fullWidth
                                multiline
                                rows={3}
                                variant="outlined"
                                value={formData.about}
                                onChange={handleChange}
                                error={!!errors.about}
                                helperText={errors.about}
                            />
                        </Grid>
                        {/* <Grid item size={12} sm={6}>
                            <TextField
                                margin="dense"
                                name="countryId"
                                label="Country ID"
                                type="text"
                                fullWidth
                                multiline
                                rows={3}
                                variant="outlined"
                                value={formData.countryId}
                                onChange={handleChange}
                                error={!!errors.countryId}
                                helperText={errors.countryId}
                            />
                        </Grid> */}
                        {/* <Grid item size={12} sm={6}>
                            <TextField
                                margin="dense"
                                name="cityId"
                                label="City ID"
                                type="number"
                                fullWidth
                                variant="outlined"
                                value={formData.cityId}
                                onChange={handleChange}
                                error={!!errors.cityId}
                                helperText={errors.cityId}
                            />
                        </Grid> */}

                    </Grid>
                </TabPanel>

                {/* Contact Details Tab */}
                <TabPanel value={tabValue} index={1}>
                    <Grid container spacing={3}>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="mobileNumber"
                                label="Mobile Number (Primary)"
                                type="tel"
                                fullWidth
                                variant="outlined"
                                value={formData.mobileNumber}
                                onChange={handleChange}
                                error={!!errors.mobileNumber}
                                helperText={errors.mobileNumber}
                            />
                        </Grid>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="workNumber"
                                label="Work Number (Primary)"
                                type="tel"
                                fullWidth
                                variant="outlined"
                                value={formData.workNumber}
                                onChange={handleChange}
                                error={!!errors.workNumber}
                                helperText={errors.workNumber}
                            />
                        </Grid>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="faxNumber"
                                label="Fax Number"
                                type="tel"
                                fullWidth
                                variant="outlined"
                                value={formData.faxNumber}
                                onChange={handleChange}
                                error={!!errors.faxNumber}
                                helperText={errors.faxNumber}
                            />
                        </Grid>
                    </Grid>
                </TabPanel>

                {/* Professional Info Tab */}
                <TabPanel value={tabValue} index={2}>
                    <Grid container spacing={3}>
                        <Grid item size={6}>
                            <FormControl fullWidth variant="outlined" margin="dense" error={!!errors.branchId}>
                                <InputLabel id="branchId-label">Branch</InputLabel>
                                <Select
                                    style={{ width: 200 }}
                                    labelId="branchId-label"
                                    name="brokerHomeOffice"
                                    value={formData?.brokerHomeOffice}
                                    onChange={saveBranchData}
                                    label="Branch ID"
                                >
                                    {/* Replace these with your actual branch options */}
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {officeData ? (
                                        officeData.map((office) => (
                                            <MenuItem key={office.value} value={office.label}>
                                                {office.label}
                                            </MenuItem>
                                        ))
                                    ) : null}
                                </Select>
                                <FormHelperText>{errors.branchId}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="privysealAlias"
                                label="PrivySeal Alias"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={formData.privysealAlias}
                                onChange={handleChange}
                                error={!!errors.privysealAlias}
                                helperText={errors.privysealAlias || "optional (used by PP integration)"}
                            />
                        </Grid>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="registrationNumber"
                                label="Registration Number"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={formData.registrationNumber}
                                onChange={handleChange}
                                error={!!errors.registrationNumber}
                                helperText={errors.registrationNumber}
                            />
                        </Grid>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="vatNumber"
                                label="VAT Number"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={formData.vatNumber}
                                onChange={handleChange}
                                error={!!errors.vatNumber}
                                helperText={errors.vatNumber}
                            />
                        </Grid>
                        {/* END NEW FIELDS */}
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="qualification"
                                label="Qualification"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={formData.qualification}
                                onChange={handleChange}
                                error={!!errors.qualification}
                                helperText={errors.qualification}
                            />
                        </Grid>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="fidelityFundCertificationYear"
                                label="Fidelity Fund Certification Year"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={formData.fidelityFundCertificationYear}
                                onChange={handleChange}
                                error={!!errors.fidelityFundCertificationYear}
                                helperText={errors.fidelityFundCertificationYear}
                            />
                        </Grid>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="fidelityFundCertificationNumber"
                                label="Fidelity Fund Certification Number"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={formData.fidelityFundCertificationNumber}
                                onChange={handleChange}
                                error={!!errors.fidelityFundCertificationNumber}
                                helperText={errors.fidelityFundCertificationNumber}
                            />
                        </Grid>
                    </Grid>
                </TabPanel>

                {/* Profile & Image Tab */}
                <TabPanel value={tabValue} index={3}>
                    <Grid container spacing={3}>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="profile.facebook"
                                label="Facebook URL"
                                type="url"
                                fullWidth
                                variant="outlined"
                                value={formData.profile.facebook}
                                onChange={handleChange}
                                error={!!errors.facebook}
                                helperText={errors.facebook}
                            />
                        </Grid>
                        <Grid item size={6}>
                            <TextField
                                margin="dense"
                                name="profile.twitter"
                                label="Twitter URL"
                                type="url"
                                fullWidth
                                variant="outlined"
                                value={formData.profile.twitter}
                                onChange={handleChange}
                                error={!!errors.twitter}
                                helperText={errors.twitter}
                            />
                        </Grid>
                        <Grid item size={6}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 2 }}>
                                <Avatar
                                    src={imagePreview}
                                    sx={{ width: 100, height: 100, mb: 2 }}
                                />
                                <input
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    id="agent-image-upload"
                                    type="file"
                                    onChange={handleImageUpload}
                                    ref={fileInputRef}
                                />
                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                    <label htmlFor="agent-image-upload">
                                        <Button
                                            variant="outlined"
                                            component="span"
                                            startIcon={<CloudUpload />}
                                        >
                                            Upload license Image
                                        </Button>
                                    </label>
                                    {imagePreview && (
                                        <IconButton
                                            color="error"
                                            onClick={removeImage}
                                            size="small"
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    )}
                                </Box>
                                {formData.profilePicture && (
                                    <Chip
                                        label="Image ready"
                                        color="success"
                                        variant="outlined"
                                        size="small"
                                        sx={{ mt: 1 }}
                                    />
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </TabPanel>
            </DialogContent>

            <DialogActions>
                <Button type="button" onClick={onClose}>Cancel</Button>
                {tabValue > 0 && (
                    <Button type="button" onClick={handleBack}>
                        Back
                    </Button>
                )}

                {tabValue < 3 ? (
                    <Button type="button" variant="contained" onClick={handleNext}>
                        Next
                    </Button>
                ) : (
                    <Button type="submit" variant="contained" color="success">
                        {sourceData ? 'Update Broker' : 'Add Broker'}
                    </Button>
                )}
            </DialogActions>

        </Box>
    );
};

export default AgentFormComponent;